module.exports = __webpack_public_path__ + "img/ic_discover.e2ab98c7.jpg";